import type { PermissionActionKey, PermissionKey } from "@/utils/types/auth";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server || !to.meta.permissions?.length) {
    return;
  }

  const authStore = useAuthStore();
  const { permissions: userPermissions } = storeToRefs(authStore);
  const hasEveryPermission = to.meta.permissions.every((permission) => {
    const separatorIndex = permission.lastIndexOf(".");
    const permissionKey = permission.slice(0, separatorIndex) as PermissionKey;
    const action = permission.slice(separatorIndex + 1) as PermissionActionKey;

    return userPermissions.value[permissionKey]?.[action] === true;
  });

  if (!hasEveryPermission) {
    throw showError({
      statusCode: 403,
      statusMessage: "ไม่มีสิทธิ์เข้าถึง",
    });
  }
});
